import React, { Component, PropTypes } from 'react';
import { Col, ControlLabel, FormGroup } from 'react-bootstrap';

class BusinessType extends Component {
  constructor(props) {
    super(props);
    const role = localStorage.getItem('role');
    const isPVCoverNote = localStorage.getItem('isPVCoverNote');
    const isCVCoverNote = localStorage.getItem('isCVCoverNote');
    let businessTypeArray = [];
    const admin = [
      { code: 'bus', name: 'Bus' },
      { code: 'fleet', name: 'Fleet' },
      { code: 'hireCar', name: 'Hire Car' },
      { code: 'motorCycle', name: 'Motor Cycle' },
      { code: 'motorTrade', name: 'Motor Trade' },
      { code: 'smartDriveCommercialVehicle', name: 'SmartDrive Commercial Vehicle' },
      { code: 'smartDrivePrivateCar', name: 'SmartDrive Private Car' },
      { code: 'specialType', name: 'Special Type' },
      { code: 'supremeMotor', name: 'SUPREME Motor' },
      { code: 'commercialVehicle', name: 'Commercial Vehicle' }
    ];
    const pv = [
      { code: 'smartDrivePrivateCar', name: 'SmartDrive Private Car' }
    ];
    const cv = [
      { code: 'smartDriveCommercialVehicle', name: 'SmartDrive Commercial Vehicle' }
    ];
    if (role === 'admin') {
      businessTypeArray = admin;
    } else {
      if (isPVCoverNote === 'true') {
        businessTypeArray = businessTypeArray.concat(pv);
      }
      if (isCVCoverNote === 'true') {
        businessTypeArray = businessTypeArray.concat(cv);
      }
    }
    this.state = {
      option: [],
      isDataLoaded: false,
      businessTypeArray
    }
  }

  render() {
    return (
      <FormGroup controlId="businessType">
        <Col componentClass={ControlLabel} sm={4}>
          Business Type
        </Col>
        <Col sm={8}>
          <select className="custom-select" onChange={this.props.handleChangeBusinessType}
            value={this.props.businessType}
            id="businessType">
              <option value="">Please Select</option>
              {this.state.businessTypeArray.map((obj, index) => {
                const counter = index;
                return (
                  <option
                    value={obj.code}
                    key={counter}
                  >{obj.name}</option>
                );
              })}
            </select>
        </Col>
      </FormGroup>
    )
  }
}

BusinessType.propTypes = {
  handleChangeBusinessType: PropTypes.func,
  businessType: PropTypes.string
};

export default BusinessType;



// WEBPACK FOOTER //
// ./src/app/components/retrieveCoverNoteComponent/businessType/BusinessType.js